import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "documentViewPage"
};
const _hoisted_2 = ["src", "alt"];
import { ref, onMounted, onBeforeUnmount, nextTick, useTemplateRef } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useDocuments } from '@/composables/useDocuments';
import HeaderBlock from './elements/HeaderBlock.vue';
import VuePdfEmbed from 'vue-pdf-embed';
import panzoom from 'panzoom';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DocumentViewPage',
    setup(__props) {
        const route = useRoute();
        useAuth();
        const { getDocument } = useDocuments();
        const documentUrl = ref(null);
        const documentName = ref('Document');
        const isPdf = ref(true);
        const panzoomInstance = ref(null);
        const panzoomContainer = useTemplateRef('panzoomContainer');
        function initPanzoom() {
            if (panzoomInstance.value)
                return;
            nextTick(() => {
                const container = panzoomContainer.value;
                if (!container)
                    return;
                let isZoomed = false;
                const instance = panzoom(container, {
                    maxZoom: 5,
                    minZoom: 1,
                    smoothScroll: true,
                    bounds: true,
                    boundsPadding: 1,
                    onTouch: (e) => {
                        if (e.touches && e.touches.length === 1 && !isZoomed) {
                            return false;
                        }
                        return true;
                    },
                });
                instance.on('zoom', () => {
                    isZoomed = instance.getTransform().scale > 1.05;
                });
                panzoomInstance.value = instance;
            });
        }
        onMounted(() => {
            const id = route.params.id;
            getDocument(id, (doc) => {
                documentUrl.value = doc.url;
                documentName.value = doc.documentName || doc.name || 'Document';
                isPdf.value = doc.isPdf !== false;
            });
        });
        onBeforeUnmount(() => {
            if (panzoomInstance.value) {
                panzoomInstance.value.dispose();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: documentName.value }, null, 8, ["title"]),
                (documentUrl.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            ref_key: "panzoomContainer",
                            ref: panzoomContainer,
                            class: "panzoom-container"
                        }, [
                            (isPdf.value)
                                ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                                    key: 0,
                                    source: documentUrl.value,
                                    onRendered: initPanzoom
                                }, null, 8, ["source"]))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: documentUrl.value,
                                    alt: documentName.value,
                                    class: "doc-image",
                                    onLoad: initPanzoom
                                }, null, 40, _hoisted_2))
                        ], 512)
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
